import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import type { IPagination } from "../data/types";
import { excludeEmptyValues, serializeFilters } from "../utils/filters";
import type InternalTransfersRequest from "../entities/internalTransfersRequest";
import type { IApprovalRepository } from "./types";
import InternalTransferResponse from "../entities/internalTransferResponse";

export default class InternalTransferRepository extends RepositoryBase<BackOfficeConnector> implements IApprovalRepository {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(pagination: IPagination, filter: InternalTransfersRequest) {
    const query = { ...filter, _approvalState: undefined };

    return this.callApi(
      api =>
        api
          .all("finance")
          .all("internal_transfers_search")
          .postPagedEntities<InternalTransferResponse>(
            {
              ...excludeEmptyValues(serializeFilters(query, false)),
              ...pagination,
            },
            InternalTransferResponse
          ),
      { ownApiFactory: () => this.apiFactory({ customVersion: "1.2" }) }
    );
  }

  update(entity: InternalTransferResponse) {
    return this.callApi(api => api.all("finance").one("internal_transfers", entity.id).putOnly(entity));
  }

  approve(id: string) {
    return this.callApi(api => api.all("finance").one("internal_transfers", id).all("approvals").postOnly({}));
  }

  export() {
    return this.callApi(api => api.all("finance").all("internal_transfers").all("exports").postOnly({}));
  }
}
